export const BULK_SMS_PROMPT_PLACEHOLDERS = ['{{count}}', '{{sampleText}}'] as const;

export const DEFAULT_BULK_SMS_PROMPT_TEMPLATE = `Сгенерируй ровно {{count}} вариантов SMS на том же языке, что образец.
Смысл и призыв к действию сохрани, формулировки, структуру и синонимы меняй.
Длина ±20% от образца, но каждый вариант строго не длиннее 1000 символов. Без нумерации и кавычек.
Верни только тексты, разделённые пустой строкой (двойной перенос строки).

Образец:
{{sampleText}}`;
